module.exports = __webpack_public_path__ + "static/media/logo.0c080549.png";